import React from 'react'
import ActionHeader from './ActionHeader.js'

const CancelAction = props => {
  return (
    <div className="panel panel-status">
      <ActionHeader request={props.request}  apiAuthHeaders={props.apiAuthHeaders} index={props.index}/>
      <div className="col-xs-9">
          <div className="cb-stepper cb-canceled-step" data-cb-rstatus="canceled" data-cb-stepper-total="1" aria-label="" role="region">
              <ol>
                  <li className="cb-stepper-skip cb-stepper-active" data-cb-stepper-step="1">
                      <span aria-hidden="true" className="cb-glyph cb-glyph-circular cb-error" data-cb-stepper-glyph="cb-error"></span><p>CANCELED</p><p></p><span className="sr-only cb-stepper-step">step 1 of 1 active</span>
                  </li>
              </ol>
          </div>
      </div>
    </div>
  )
}
export default CancelAction
